import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";
export function Menu() {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top">
        <Link to="/">
          <FontAwesomeIcon icon={faArrowLeftLong} />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse text-white ml-4"
          id="navbarNav"
        >
          <ul className="navbar-nav">
            <Link to="/Hello">
              <li className="nav-item active ml-4 text-secondary">Home </li>
            </Link>
            <Link to="/Card">
              <li className="nav-item active ml-4 text-secondary ">Card </li>
            </Link>
            <Link to="/League">
              <li className="nav-item active ml-4 text-secondary">
                Super League
              </li>
            </Link>
            <Link to="/Social">
              <li className="nav-item active ml-4 text-secondary">Social</li>
            </Link>
            <Link to="/Noti">
              <li className="nav-item active ml-4 text-secondary">
                Notification
              </li>
            </Link>
            <Link to="/Login">
              <li className="nav-item active ml-4 text-secondary">Login</li>
            </Link>
            <Link to="/Tech">
              <li className="nav-item active ml-4 text-secondary">TeachCard</li>
            </Link>
            <Link to="/Count">
              <li className="nav-item active ml-4 text-secondary">Hook</li>
            </Link>
            <Link to="/Fruit">
              <li className="nav-item active ml-4 text-secondary">Fruit</li>
            </Link>
            <Link to="/Smile">
              <li className="nav-item active ml-4 text-secondary">Feedback</li>
            </Link>
            <Link to="/Sample1">
              <li className="nav-item active ml-4 text-secondary">Cart</li>
            </Link>
            <Link to="/Sample">
              <li className="nav-item active ml-4 text-secondary">Food</li>
            </Link>
            <Link to="/Datefunction">
              <li className="nav-item active ml-4 text-secondary">
                Datefunction
              </li>
            </Link>
            <Link to="/Weatherindia">
              <li className="nav-item active ml-4 text-secondary">Weather</li>
            </Link>
            <Link to="/Profilemenu">
              <li className="nav-item active ml-4 text-secondary">Profile</li>
            </Link>
          </ul>
        </div>
      </nav>
    </>
  );
}
